import React from "react";
import { Fillter } from "./Fillter";
import { ReportsList } from "./ReportsList";

export const Favorite = ({
  selectedId,
  setId,
  rowsPerPage,
  setRowsPerPage,
  isLoading,
  page,
  setPage,
  getReports,
  count,
  data,
  fillter,
  onSearchChange,
  sortReport,
  setDuolicatetModal,
  setDuolicatetData,
}) => {
  return (
    <div className="">
      <Fillter fillter={fillter} onSearchChange={onSearchChange} />
      <ReportsList
        selectedId={selectedId}
        setId={setId}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        isLoading={isLoading}
        page={page}
        setPage={setPage}
        getReports={getReports}
        count={count}
        data={data}
        filters={fillter}
        sortReport={sortReport}
        setDuolicatetModal={setDuolicatetModal}
        setDuolicatetData={setDuolicatetData}
      />
    </div>
  );
};
